import styled from '@emotion/styled';
import { r, rInset } from '../../../shared/lib/responsive';

export const Card = styled.div`
  position: relative;
  width: 100%;
  ${r('min-height', 74)}
  ${rInset('padding', 5)}
  border-radius: var(--radius-restaurant-card);
  background: var(--color-restaurant-card);
  box-shadow: var(--shadow-restaurant);
  overflow: hidden;
`;

export const TopShadow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  ${r('height', 18)}
  border-radius: var(--radius-restaurant-card) var(--radius-restaurant-card) 0 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.14) 0%, rgba(0, 0, 0, 0) 100%);
  pointer-events: none;
  z-index: 1;
`;

export const Body = styled.div`
  position: relative;
  z-index: 0;
  display: flex;
  align-items: center;
  gap: var(--restaurant-thumb-gap);
  ${r('padding-right', 36)}
`;

export const Thumb = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  ${r('width', 64)}
  ${r('height', 64)}
  border-radius: var(--radius-thumb-restaurant);
  background: var(--color-card-active);
  border: 1px solid var(--color-thumb-border);
  overflow: hidden;
`;

export const Logo = styled.img`
  ${r('width', 37)}
  ${r('height', 24)}
  object-fit: contain;
`;

export const Meta = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: var(--restaurant-meta-gap);
  min-width: 0;
`;

export const Name = styled.p`
  margin: 0;
  font-family: var(--font-sans);
  font-weight: var(--font-weight-bold);
  ${r('font-size', 15)}
  line-height: 1;
  letter-spacing: var(--letter-spacing-tight);
  color: var(--color-text-restaurant);
`;

export const Distance = styled.p`
  margin: 0;
  font-family: var(--font-sans);
  font-weight: var(--font-weight-regular);
  font-size: var(--type-restaurant-distance-size);
  line-height: 1;
  letter-spacing: var(--letter-spacing-tight);
  color: var(--color-text-restaurant);
`;

export const Desc = styled.p`
  margin: 0;
  font-family: var(--font-sans);
  font-weight: var(--font-weight-regular);
  font-size: var(--type-restaurant-desc-size);
  line-height: 1;
  letter-spacing: var(--letter-spacing-tight);
  color: var(--color-text-restaurant-desc);
`;

export const StarButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${r('right', 16)}
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  ${r('width', 18)}
  ${r('height', 18)}
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &:focus-visible {
    outline: 2px solid var(--color-cta-reward);
    ${r('outline-offset', 2)}
    border-radius: 2px;
  }
`;

export const StarIcon = styled.svg<{ $filled?: boolean }>`
  display: block;
  ${r('width', 18)}
  ${r('height', 18)}
  pointer-events: none;
  flex: none;

  path {
    fill: ${({ $filled }) =>
      $filled ? 'var(--color-cta-reward)' : 'var(--color-star-empty)'};
    transition: fill 0.15s ease;
  }
`;
